<template lang="pug">
button.v-instruction.instruction-btn.flc(v-if="data && data.html"
		type="button"
		:aria-label="data.buttonText || data.title"
		@click="open")
	//- Иконка ВСТРОЕНА, а не взята из sprite.svg: спрайт отдаётся с max-age 30 дней
	//- и подключается без версии в URL, поэтому у вернувшихся посетителей ещё лежит
	//- старый файл без новых символов и иконка не отрисовывается (проверено 17.08.2026).
	span.instruction-btn__icon.flc
		svg.instruction-btn__icon-svg(viewBox="0 0 24 24" aria-hidden="true" focusable="false")
			circle(cx="12" cy="12" r="10.4" fill="none" stroke="currentColor" stroke-width="1.6")
			path(fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
					d="M9.25 9.6a2.75 2.75 0 1 1 3.35 2.68c-.37.12-.6.47-.6.86v1.2")
			circle(cx="12" cy="17.05" r="1.15" fill="currentColor")
	span.instruction-btn__text(v-if="data.buttonText") {{ data.buttonText }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import {openInstruction, autoOpenInstruction} from '../scripts/helpers/instruction.js';

/**
 * Кнопка «? Инструкция» + всплывающее окно с подсказкой.
 *
 * Самостоятельный вариант инструмента — для страниц ЛК без формы (списки,
 * настройки и т.п.): печатается хелпером showInstruction() из tools.php.
 * Внутри формы ad.create кнопку рисует v-form по ключу instruction в JSON формы,
 * но открывает окно тем же helper'ом.
 */
export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		};
	},

	methods: {
		dataSet(data) {
			this.data = data;
			autoOpenInstruction(data);
		},

		open() {
			openInstruction(this.data);
		}
	}
};
</script>
